import { useEffect, useState } from "react";
import { orgSettingsApi } from "./orgSettingsApi";
import { DEFAULT_ACTIVITY_TYPES, type ActivityType } from "./activityTypes";

/** Log-activity types for this organisation. Defaults stay visible if settings cannot be read. */
export function useLoggedActivityTypes(orgId: string): ActivityType[] {
  const [types, setTypes] = useState<ActivityType[]>(DEFAULT_ACTIVITY_TYPES);

  useEffect(() => {
    if (!orgId) return;
    let cancelled = false;
    orgSettingsApi.listActivityTypes(orgId).then((rows) => {
      if (!cancelled && rows.length > 0) setTypes(rows);
    }).catch(() => {
      /* The built-in list stays in place. */
    });
    return () => {
      cancelled = true;
    };
  }, [orgId]);

  return types;
}
